import { Button } from '@bpinternal/ui-kit-next'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft, ChevronsUpDown, Plus } from 'lucide-react'
import { Boundary, Page } from '~/components'
import { PageTitleInput } from '~/components/PageTitleInput'
import { useIsAdkBot } from '~/features/bots/hooks/useIsAdkBot'
import { showApiDocumentationDialog } from '~/features/knowledge-bases/components/ApiDocumentationModal'
import { showAddKnowledgeSourceDialog } from '~/features/knowledge-bases/components/knowledge-source/AddKnowledgeSource/AddKnowledgeSourceDialog'
import { KnowledgeSourceTable } from '~/features/knowledge-bases/components/knowledge-source/KnowledgeSourceTable'
import { useKnowledgeBase, useUpdateKnowledgeBase } from '~/features/knowledge-bases/hooks/useKnowledgeBase'

const MAX_KBNAME_LENGTH = 64

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspaceId, botId, kbId } = Route.useParams()
  const { data: kb } = useKnowledgeBase({ workspaceId, botId, kbId })
  const { mutate: renameKb, isPending, isSuccess } = useUpdateKnowledgeBase()
  const isAdkBot = useIsAdkBot({ workspaceId, botId })

  return (
    <Page
      actions={
        isAdkBot ? null : (
          <Button
            className="hidden md:flex"
            variant="outline"
            onClick={() => showApiDocumentationDialog({ workspaceId })}
          >
            <ChevronsUpDown className="rotate-90" />
            API
          </Button>
        )
      }
      primaryActions={
        isAdkBot ? null : (
          <Button
            className="h-full w-full md:w-fit"
            onClick={(e) => {
              e.stopPropagation()
              showAddKnowledgeSourceDialog({ workspaceId, botId, kbId: kb.oldKbId || kbId })
            }}
          >
            <Plus />
            Add Knowledge Source
          </Button>
        )
      }
      title={
        <div className="flex w-full gap-2">
          <Link to="/workspaces/$workspaceId/bots/$botId/knowledge-bases" params={{ workspaceId, botId }}>
            <Button variant="ghost" size="icon" className="h-8 w-8">
              <ArrowLeft />
            </Button>
          </Link>
          <PageTitleInput
            defaultName={kb.name}
            onRename={(newName: string) => {
              renameKb({
                botId,
                workspaceId,
                name: newName,
                id: kbId,
              })
            }}
            isPending={isPending}
            isSuccess={isSuccess}
            maxLength={MAX_KBNAME_LENGTH}
            showError
          />
        </div>
      }
    >
      <Boundary>
        <KnowledgeSourceTable
          workspaceId={workspaceId}
          botId={botId}
          kbId={kb.oldKbId || kbId}
          knowledgeBaseName={kb.name}
        />
      </Boundary>
    </Page>
  )
}
